






























































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { Meta } from '@/helpers/decorators'
import Box from '@/components/common/Box.vue'
import InputPassword from '@/components/common/InputPassword.vue'
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

enum AccountType {
  Enterprise = 'enterprise',
  Individual = 'individual'
}

@Component({
  components: {
    Box,
    InputPassword
  }
})
export default class Login extends Mixins(Form, Errors) {
  type: string = AccountType.Enterprise
  companyName: string = null
  firstName: string = null
  lastName: string = null
  email: string = null
  password: string = null
  formLoading: boolean = false
  companyCreate: boolean = null
  displayErrors: any
  step: number = 1
  $refs: {
    signup: HTMLFormElement
  }
  plan: string = 'individual'

  @Action('setNavigatorLocale', { namespace: 'user' }) setNavigatorLocale
  @Action('createUser', { namespace: 'user' }) createUser
  @Action('updateUserRights', { namespace: 'user' }) updateUserRights
  @Action('updateInformations', { namespace: 'user' }) updateInformations

  @Getter('token') token

  @Meta
  metas() {
    return {
      title: this.$t('signup.button.submit'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  @Watch('companyCreate')
  updateType(creation) {
    if (creation) {
      this.type = AccountType.Enterprise
    } else {
      this.type = AccountType.Individual
      this.plan = 'coworker'
    }
  }

  get isEnterprise() {
    return this.type === AccountType.Enterprise
  }

  mounted() {
    this.$refs.signup.reset()
    this.$validator.validate('password')
  }

  switchToIndividual() {
    this.step = 1
    this.type = AccountType.Individual
    this.password = null
    this.plan = 'individual'
  }

  async load() {
    if (this.isEnterprise && this.step === 1) {
      this.step = 2
      return
    }
    try {
      if (this.companyCreate === null && this.type === AccountType.Enterprise) {
        return
      }
      this.formLoading = true
      await this.$validator.validateAll()
      await this.createUser({ email: this.email, password: this.password})
      await this.updateUserRights()
      if (this.isEnterprise) {
        await this.updateInformations({
          company: this.companyName,
          firstName: this.firstName,
          lastName: this.lastName
        })
        window.location.href = `${this.$trialUrl}/#/login/${this.token}`
      } else {
        this.$router.push({ name: 'home', query: { plan: this.plan } })
      }
    } catch (error) {
      this.displayErrors(error)
      this.step = 1
      this.type = AccountType.Enterprise
    } finally {
      this.formLoading = false
    }

  }
}
